import enUS from './en/index.js';
import frCA from './fr/index.ts';
export default {
  en: enUS,
  fr: frCA
};
